export default {
  gameday: {
    name: 'GameDay',
    logo: 'https://cdn.teammo.io/icon-gameday-white.png',
  },
};
